const recruiterHiringHubScoreAdapter = (recruiter) => {
  const recruiterHHScore =
    recruiter.recruiterHiringHubScore !== undefined
      ? recruiter.recruiterHiringHubScore.bufferedScore
      : recruiter.hiringHubScore;

  return recruiterHHScore;
};

export default recruiterHiringHubScoreAdapter;
